import { MyAccountUrl } from "../directives/utilities/urls";
export default function basketFeeSummary() {
    return {
        showErrorMesage: "",
        showSuccessMesage: "",
        lineItems: [],
        hasMore: false,
        showLoader: false,
        basketTotal: 0,
        total_Amount: '',
        headingName:'',
        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
                undefined,
                options
            );
            return formattedDate;
        },
        btnCancelClick() {
            this.showLoader = true;
            fetch("/api/Basket/cancel-declare-candidacy", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        window.location.href = MyAccountUrl;
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        removeCartList(item) {
            if (confirm("Are you sure to remove this course from your cart?")) {
                var jsonData = JSON.stringify({
                    "UserSessionId": "",
                    "AcademicYear": item.academicYear,
                    "AcademicTerm": item.academicTerm,
                    "AcademicSession": item.academicSession,
                    "SerialId": item.serialId
                });
                this.showLoader = true;

                fetch("/api/Checkout/delete-course-from-cart", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: jsonData,
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.showSuccessMesage = "Course removed succesfully."
                            this.bindCartList();
                        } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                        }
                    });
            }

        },
        btnCancelClick() {
            this.showLoader = true;
            fetch("/api/Basket/cancel-declare-candidacy", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        window.location.href = MyAccountUrl;
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        bindBasketList() {
            this.showLoader = true;
            this.enrollmentCartList = [];
            fetch("/api/Basket/GetBasketList", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        if (response.basketList.length > 0) {
                            this.basketTotal = response.basketTotal;
                            if (response.basketList[0].saleType == 3) {
                                this.headingName = "Fee Summary";
                            } else {
                                this.headingName = response.basketList[0].saleType == 1 ? response.basketList[0].description + " Fee Summary" : response.basketList[0].name + " Fee Summary";
                            }
                            
                            Array.prototype.push.apply(this.enrollmentCartList, response.basketList);
                        } else {
                            window.location.href = MyAccountUrl;
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        init() {
            this.bindBasketList();
        },
    };
}
